import { DataResponse } from '../../services/response';
import { observable, runInAction } from 'mobx';
import { DataCategory, ICategoryMdServices, SearchCategoryPayload } from 'services/RawData/category_services';

export type categoryMdStore = {
  searchResponse: DataResponse<Array<DataCategory>>;
  detailResponse: DataResponse<DataCategory | undefined>;
  crudResponse: DataResponse<boolean>;
  deleteResponse: DataResponse<boolean>;
};

export interface ICategoryMdPresenter {
  createStore(): categoryMdStore;
  searchCategory(store: categoryMdStore, data: SearchCategoryPayload): Promise<void>;
  getCategoryById(store: categoryMdStore, categoryId: string): Promise<void>;
  createCategory(store: categoryMdStore, data: Omit<DataCategory, 'stt' | 'categoryId'>): Promise<void>;
  updateCategory(store: categoryMdStore, categoryId: string, data: Omit<DataCategory, 'stt' | 'categoryId'>): Promise<void>;
  deleteCategory(store: categoryMdStore, categoryId: string): Promise<void>;
}

export function createCategoryMdPresenter({ categoryMdServices }: { categoryMdServices: ICategoryMdServices }): ICategoryMdPresenter {
  return {
    createStore: () =>
      observable({
        searchResponse: { data: [], message: '', isSuccess: false },
        detailResponse: { data: undefined, message: '', isSuccess: false },
        crudResponse: { data: false, message: '', isSuccess: false },
        deleteResponse: { data: false, message: '', isSuccess: false },
      }),
    searchCategory: async (store, data) => {
      try {
        const result = await categoryMdServices.searchCategory(data);
        runInAction(() => {
          store.searchResponse.data = result.data;
          store.searchResponse.message = result.message;
          store.searchResponse.isSuccess = result.isSuccess;
          store.searchResponse.paging = {
            totalCount: result.paging?.pagesCount,
            recordsTotal: result.paging?.recordsTotal,
            pageSize: result.paging?.resultsCount,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    getCategoryById: async (store, categoryId) => {
      try {
        const result = await categoryMdServices.getCategoryById(categoryId);
        runInAction(() => {
          store.detailResponse.data = result.data;
          store.detailResponse.message = result.message;
          store.detailResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    createCategory: async (store, data) => {
      try {
        const result = await categoryMdServices.createCategory(data);
        runInAction(() => {
          store.crudResponse.data = result.data;
          store.crudResponse.message = result.message;
          store.crudResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateCategory: async (store, categoryId, data) => {
      try {
        const result = await categoryMdServices.updateCategory(categoryId, data);
        runInAction(() => {
          store.crudResponse.data = result.data;
          store.crudResponse.message = result.message;
          store.crudResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    deleteCategory: async (store, categoryId) => {
      try {
        const result = await categoryMdServices.deleteCategory(categoryId);
        runInAction(() => {
          store.deleteResponse.data = result.data;
          store.deleteResponse.message = result.message;
          store.deleteResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}


